/*
 * @Description:
 * @Author: xz
 * @Date: 2023-11-17 14:27:55
 * @LastEditTime: 2024-06-11 20:54:05
 * @LastEditors: xz
 */
import request from '../../utils/request'
export function addFileType(params) {
  return request({
    url: "/informationManage/addFileType",
    method: "POST",
    params
  })
}
// 获取所有的tag
export function findAllType() {
  return request({
    url: "/informationManage/findAllType",
    method: "GET",

  })
}
// 删除标签

export function delFileType(params) {
  return request({
    url: "/informationManage/delFileType",
    method: "DELETE",
    params
  })
}
// 获取第一层目录

export function findRootDirectory(params) {
  return request({
    url: "/informationManage/findRootDirectory",
    method: "GET",
    params
  })
}
//获取当前目录下的内容x
export function findContentInCurrentDirectory(params) {
  return request({
    url: "informationManage/findContentInCurrentDirectory",
    method: "GET",
    params
  })
}
// 新增文件

export function addFileInfo(data) {
  return request({
    url: "informationManage/addFileInfo",
    method: "POST",
    data
  })
}
// 删除文件或者是目录
export function delFileDirectory(params) {
  return request({
    url: "informationManage/delFileDirectory",
    method: "DELETE",
    params
  })
}
// 模糊搜索
export function likeFindByCondition(params) {
  return request({
    url: "informationManage/likeFindByCondition",
    method: "GET",
    params
  })
}
// 文件下载
export function download(params) {
  return request({
    url: "informationManage/download",
    method: "GET",
    params,
    responseType: "blob"
  })
}
// 添加目录

export function addFileDirectory(data) {
  return request({
    url: "informationManage/addFileDirectory",
    method: "POST",
    data,

  })
}
// 编辑保存
export function editFileInfo(params) {
  return request({
    url: "informationManage/editFileInfo",
    method: "POST",
    params,

  })
}

//入库操作
export function saveDataBase(params) {
  return request({
    url: "informationManage/inWarehousing",
    method: "GET",
    params,
  })
}
export function addPlanWithUploadFile(params) {
  return request({
    method: "post",
    url: '/template/addPlanWithUploadFile',
    default_headers: 'multipart/form-data',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/file.js